import { useAppSelector } from '../../../app/hooks'
import { InitState } from '../../../redux/reducers/root/initialState'
import { useFeatureSwitch } from '../../../utils/features/FeatureSwitchContext'
import { FeatureSwitch } from '../../../utils/features/featureSwitches'
import { getRecommendedPriceExperimentState } from '../../../utils/features/recommendedPriceExperiment'

export function useIsRecommendedPriceEnabled() {
  const { value: recommendedPriceFeatureValue, isLoadedFromBackend: isRecommendedPriceFeatureLoadedFromBackend } =
    useFeatureSwitch(FeatureSwitch.PPA_12616_RECOMMENDED_PRICE_FOURTH_ITERATION)
  const isRecommendedPriceFlowOptionEnabled = useAppSelector(
    (state: InitState) => state.flowFeature.flowInformation.options?.recommendedPriceEnabled === true
  )

  return getRecommendedPriceExperimentState({
    isRecommendedPriceFlowOptionEnabled,
    isRecommendedPriceFeatureLoadedFromBackend,
    recommendedPriceFeatureValue,
  }).isRecommendedPriceEnabled
}
